import { isEmpty } from '../utils/validations';

export class PhoneVerification {
    public completed: boolean;
    public skipped: boolean;
    public phone: string;

    constructor(object?: any ) {
        object = object ? object : {};
        this.completed = isEmpty(object.completed) ? false : object.completed;
        this.skipped = isEmpty(object.skipped) ? false : object.skipped;
        this.phone = isEmpty(object.bank) ? null : object.phone;
    }
}
